// Library imports
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import store, { RootState } from "store/index";

// Local imports
import FloatingSidebarTwo from "modules/Common/Components/FloatingSidebarTwo";
import NewListAsider from "./NewListAsider";
import { closeCreateNewListAsider, closeOverlay, GLOBAL_ACTION } from "modules/GlobalActions";
import { clearPeopleSearch, getRecommendedPeople, resetSelectAllRecommendedContactsAction } from "modules/Campaigns/CampaignAssets/actions";
import { getQueryListId } from "utils";

interface IFloatingNewListAsiderProps {
  showNewListAsider?: any;
  setShowNewListAsider?: any;
  similarContacts?: any[];
  contactSidebarId?: number;
  inDetailProfile?: boolean;
  tab?: string;
  inList?: boolean;
  selectAllFlag?: boolean;
  // inProfiled?: boolean;
  unselectedContactIdsState?: any[];
  deleteAllTotalCount?: number;
  selectAll?: boolean;
  selectAllList?: boolean;
  selectedCount?: number;
  deleteAllFlag?: boolean;
  selectedOrganization?: string[];
  selectedDesignation?: string[];
  selectedPersonality?: string[];
  selectedStatus?: string[];
  idprefix?: string;
  idForRecommendedContacts?: string;
  fromGloabalListing?: boolean;
  globalList?: boolean;
  addPeopleMode?: boolean;

}
const FloatingNewListAsider: React.FC<IFloatingNewListAsiderProps> = (props) => {
  // Local States

  const [showBrowseAudienceAsider, setShowBrowseAudienceAsider] = useState(false);
  const [contactsFromBrowse, setContactsFromBrowse]: any[] = useState([]);
  const [contactsFromBrowseAddPeople, setContactsFromBrowseAddPeople]: any[] = useState([]);
  const [removedBrowseContactId, setRemovedBrowseContactId] = useState(0);
  const [selectedContactIds, setSelectedContactIds] = useState(
    props?.similarContacts ? props?.similarContacts : Array<object>()
  );
  const [selectedContactsFromList, setSelectedContactsFromList] = useState([]);
  const [aToggle, setAToggle] = useState(false);
  const [firstMountSkip, setFirstMountSkip] = useState(false);

  // Redux States
  const addSuccess = useSelector((state: RootState) => state.audienceLists.addList.success);
  const closeCreateNewListAsiderCheck = useSelector(
    (state: RootState) => state.uiReducer.closeCreateNewListAsiderCheck
  );
  const isSelectAllRecommendedContacts = useSelector((state: RootState) => state.recommendedPeople.isSelectAllRecommendedContacts);
  // const selectedRecommendedContacts = useSelector((state: RootState) => state.recommendedPeople.selectedRecommendedContacts);
  const selectedRecommendedContacts = useSelector((state: RootState) => state.selectedRecommendedContacts.selectedContacts);
  const selectedRecommendedContactsIds = useSelector((state: RootState) => state.selectedRecommendedContacts.selectedContactsIds);
  const selectAllRecommendedContacts = useSelector((state: RootState) => state.selectedRecommendedContacts.selectAllRecommendedContacts);
  const unSelectAllRecommendedContacts = useSelector((state: RootState) => state.selectedRecommendedContacts.unSelectAllRecommendedContacts);




  useEffect(() => {
    // console.log("selectedRecommendedContacts", selectedRecommendedContacts);
    // console.log("selectedRecommendedContactsIds", selectedRecommendedContactsIds);
    // if (isSelectAllRecommendedContacts) {
    //   if (selectedRecommendedContacts.length > selectedContactIds.length) {
    //     let contacts = selectedRecommendedContacts.map((contact: any) => ({ id: contact.id, name: contact.name }));
    //     setSelectedContactIds(contacts)
    //   };
    // } else {
    //   if (selectedRecommendedContacts.length === 0) {
    //     setSelectedContactIds([])
    //   }
    // }
  }, [isSelectAllRecommendedContacts, selectedRecommendedContacts]);

  useEffect(() => {
    if (isSelectAllRecommendedContacts) {
      if (selectedRecommendedContacts.length > selectedContactIds.length) {
        let contacts = selectedRecommendedContacts.map((contact: any) => ({
          id: contact.id,
          name: contact.name === " " ? contact.email : contact.name,
        }));
        setSelectedContactIds(contacts);
      }
    } else {
      if (selectedRecommendedContacts.length === 0) {
        setSelectedContactIds([])
      }
    }
  }, [isSelectAllRecommendedContacts, selectedRecommendedContacts]);


  // Component Logic
  useEffect(() => {
    if (props?.tab === "listsTab") {
      if (aToggle) document.body.classList.add("new-list-asider-open");
      else document.body.classList.remove("new-list-asider-open");
    } else if (props?.tab === "peopleTab") {
      if (aToggle) document.body.classList.add("new-list-asider-open-people");
      else document.body.classList.remove("new-list-asider-open-people");
    }
    if (aToggle) {
      getRecommendedPeople(0, 50, props.selectAllFlag, getQueryListId().toString(), props.unselectedContactIdsState);
    }
  }, [aToggle]);

  useEffect(() => {
    if (firstMountSkip) {
      handleCancelCreateNewList();
    } else {
      setFirstMountSkip(true);
    }
  }, [closeCreateNewListAsiderCheck]);

  useEffect(() => {
    if (props?.similarContacts) setSelectedContactIds(props?.similarContacts);
  }, [props?.similarContacts]);

  useEffect(() => {
    if (addSuccess) {
      if (!props.inDetailProfile) setSelectedContactIds([]);
    }
  }, [addSuccess]);

  function handleCancelCreateNewList() {
    setAToggle(false);
    store.dispatch({
      type: GLOBAL_ACTION.CLOSE_CREATE_NEW_LIST_ASIDER_FROM_CANCEL,
    });
    if (props.inDetailProfile) {
      props?.similarContacts && setSelectedContactIds(props?.similarContacts);
    } else setSelectedContactIds([]);
    setShowBrowseAudienceAsider(false);
    resetSelectAllRecommendedContactsAction();
    clearPeopleSearch(); // reset search field when closing the asider
    !props.inDetailProfile && closeOverlay();
  }
  function handleOnClickBrowse() {
    setShowBrowseAudienceAsider(true);
  }
  function onClickAudienceDone() {
    setShowBrowseAudienceAsider(false);
  }
  function handleAddPeople(id: number, name: string, audience_type: string, email?: string) {
    if (audience_type === "contact") {
      const selectedContact = selectedContactIds.find((contact: any) => contact.id === id);
      if (name === "" && email !== undefined) {
        name = email;
      }
      if (selectedContact) {
        // handleRemovePeople({ id, name });
        setSelectedContactIds(selectedContactIds.filter((contact: any) => contact.id !== selectedContact.id));
        const filteredArrAddPeople = contactsFromBrowseAddPeople.filter((contact: any) => contact.id !== id);
        setContactsFromBrowseAddPeople([...filteredArrAddPeople]);
      } else {
        setSelectedContactIds([...selectedContactIds, { id, name }]);
        setContactsFromBrowseAddPeople([...contactsFromBrowseAddPeople, { id, name }]);
      }
    }
  }

  function removeContact(index: number) {
    const updatedContactIds = [...selectedContactIds];
    if (index >= 0) {
      updatedContactIds.splice(index, 1);
      setSelectedContactIds(updatedContactIds);
    }
  }
  function isSelected(id: number) {
    const index = selectedContactIds.findIndex((contact: any) => contact.id === id);
    return index >= 0;
  }

  return (
    <>
      <div
        onClick={() => {
          setAToggle(true);
        }}
      >
        {props.children}
      </div>
      <FloatingSidebarTwo
        inCreateNewList={true}
        inDetailProfile={props.inDetailProfile}
        isToggle={aToggle}
        rightMargin="0px"
        topMargin="0px"
        handleAddPeople={handleAddPeople}
        fitContent={false}
        isToggleAsider={true} // set to true to always show recommended people
        keywordAsider={true}
        onClickAudienceDone={onClickAudienceDone}
        hideRecommendedList={true}
        isPersonAdded={isSelected}
        enableScrollForContacts={true}
        subtractWidth={"1098px"}
        disableMaxHeight={true}
        selectedContactIds={selectedContactIds?.map((item) => {
          if (item !== undefined) {
            return item?.id ?? item?.value;
          }
        })}
        selectAllFlag={props.selectAllFlag}
        unselectedContactIdsState={props.unselectedContactIdsState}
        idForRecommendedContacts={props?.idForRecommendedContacts}
      >
        <NewListAsider
          setAToggle={setAToggle}
          isOpen={aToggle}
          handleAddPeople={handleAddPeople}
          // inProfiled={props.inProfiled}
          unselectedContactIdsState={props.unselectedContactIdsState}
          selectAllFlag={props.selectAllFlag}
          inList={props.inList}
          fromSimilar={props.inDetailProfile}
          contactSidebarId={props.contactSidebarId}
          aToggle={true}
          onCancel={handleCancelCreateNewList}
          handleOnClickBrowsePeople={handleOnClickBrowse}
          contacts={props?.similarContacts}
          selectedContactIdsFromBrowse={selectedContactIds}
          setSelectedContactIdsFromBrowse={setSelectedContactIds}
          setContactsFromBrowseAddPeople={setContactsFromBrowseAddPeople}
          contactsFromBrowse={contactsFromBrowse}
          contactsFromBrowseAddPeople={contactsFromBrowseAddPeople}
          removedBrowseContactId={removedBrowseContactId}
          setRemovedBrowseContactId={setRemovedBrowseContactId}
          removeContact={removeContact}
          deleteAllTotalCount={props.deleteAllTotalCount}
          selectAll={props.selectAll}
          selectAllList={props.selectAllList}
          selectedCount={props.selectedCount}
          deleteAllFlag={props.deleteAllFlag}
          selectedOrganization={props.selectedOrganization}
          selectedDesignation={props.selectedDesignation}
          selectedPersonality={props.selectedPersonality}
          selectedStatus={props.selectedStatus}
          idprefix={props.idprefix}
          fromGloabalListing={props.fromGloabalListing}
          globalList={props.globalList}
          addPeopleMode={props.addPeopleMode}
        />
      </FloatingSidebarTwo>
    </>
  );
};

export default FloatingNewListAsider;
